import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps, toast } from "sonner"

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
    const { resolvedTheme } = useTheme()

    const darkToastStyle =
        resolvedTheme === "dark"
            ? ({
                  "--normal-bg": "#ffffff",
                  "--normal-text": "var(--fg-inverse)",
                  "--normal-border": "var(--border-default)",
                  "--gray11": "var(--fg-inverse)",
              } as React.CSSProperties)
            : undefined

    return (
        <Sonner
            theme={resolvedTheme as ToasterProps["theme"]}
            className="toaster group"
            toastOptions={{
                ...toastOptions,
                style: { ...darkToastStyle, ...toastOptions?.style },
            }}
            {...props}
        />
    )
}

export { Toaster, toast }
